import { persisted, type Options } from "svelte-persisted-store";

import type { ValueWritable } from "./valueStore";

export function persistedWritable<T>(key: string, value: T, options?: Options<T>): ValueWritable<T> {
    const store = persisted<T>(key, value, options);

    store.subscribe((val) => value = val);

    return {
        ...store,
        get value() {
            return value!;
        },
    };
}
